import { createPortal } from "react-dom";

import { ADF } from "@atlassiansox/bxp-content-framework";

import { useModal } from "../../components";

import { TooltipContent } from "./TooltipContent";

export type ToolTipProps = {
    document: ADF.Document;
    modalId: string;
    isOpen: boolean;
    parentRef: React.MutableRefObject<HTMLElement | null>;
};

export const Tooltip = ({
    document,
    modalId,
    isOpen,
    parentRef
}: ToolTipProps) => {
    const modal = useModal(modalId, isOpen);

    if (!modal) {
        return null;
    }

    return createPortal(
        <TooltipContent toolTipText={document} trigger={parentRef} />,
        modal
    );
};
